import { useNavigate } from 'react-router-dom';
import Badge, { statusTone } from '@/components/base/Badge';
import { useAppStore } from '@/store/AppStore';

export default function TodaySchedule() {
  const { jobs } = useAppStore();
  const navigate = useNavigate();

  const todaysJobs = [...jobs].sort((a, b) => a.time.localeCompare(b.time));

  return (
    <div className="overflow-hidden rounded-lg border border-background-200 bg-white">
      <div className="flex items-center justify-between border-b border-background-100 px-5 py-4">
        <h2 className="font-heading text-[15px] font-bold text-foreground-950">Bugünün Programı</h2>
        <button
          type="button"
          onClick={() => navigate('/randevu')}
          className="flex items-center gap-1 whitespace-nowrap text-xs font-semibold text-primary-600 hover:text-primary-700"
        >
          Takvimi Aç
          <i className="ri-arrow-right-s-line text-sm" />
        </button>
      </div>

      <div className="px-5 py-2">
        {/* Prep row */}
        <div className="flex gap-4 py-3">
          <div className="flex w-16 shrink-0 flex-col items-center">
            <span className="text-xs font-semibold text-foreground-400">09:00</span>
          </div>
          <div className="relative flex-1">
            <div className="absolute -left-1 top-1.5 h-2.5 w-2.5 rounded-full border-2 border-background-200 bg-white" />
            <div className="text-sm font-semibold text-foreground-700">Ekip Hazırlığı</div>
            <div className="text-xs text-foreground-400">Ekipman ve malzeme kontrolü</div>
          </div>
        </div>

        {todaysJobs.map((job) => (
          <div key={job.id} className="flex gap-4 py-3">
            <div className="w-16 shrink-0 text-xs font-semibold text-foreground-500">{job.time}</div>
            <div className="relative flex-1 border-l border-background-200 pl-5 pb-1">
              <div className="absolute -left-[5px] top-1.5 h-2.5 w-2.5 rounded-full bg-accent-500" />
              <button
                type="button"
                onClick={() => navigate('/bugunun-isleri')}
                className="group block w-full text-left"
              >
                <div className="flex items-center justify-between gap-3">
                  <span className="font-heading text-sm font-bold text-foreground-900 group-hover:text-primary-600">
                    {job.customerName}
                  </span>
                  <Badge tone={statusTone(job.status)}>{job.status}</Badge>
                </div>
                <div className="mt-0.5 text-[13px] text-foreground-600">{job.service}</div>
                <div className="mt-0.5 flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-map-pin-line text-[13px]" />
                    {job.location}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-group-line text-[13px]" />
                    {job.team}
                  </span>
                </div>
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}